module.exports={
	"Scope": "Location-List",
	"CoreEntity": "Location",
	"TitleTemplate": "Locations",
	"Descriptors":
	{
		"Name":
		{
			"Name": "Name",
			"Hash": "Name",
			"PictDashboard": {}
		}
	}
}